module.exports = __webpack_public_path__ + "marker-shadow.44a526eed258222515aa.png";